import axios from 'axios';
import { API_URL } from '../config';
import initialState from './initialState';
import { Warehouse } from '@mui/icons-material';

export const getBins = ({ bins }) => bins;

const reducerName = 'bins';
const createActionName = (name) => `app/${reducerName}/${name}`;

const LOAD_BINS = createActionName('LOAD_BINS');
const ADD_BIN = createActionName('ADD_BIN');
const EDIT_BIN = createActionName('EDIT_BIN');
const DELETE_BIN = createActionName('DELETE_BIN');

export const loadBins = (payload) => ({ payload, type: LOAD_BINS });
export const addBin = (payload) => ({ payload, type: ADD_BIN });
export const editBin = (payload) => ({ payload, type: EDIT_BIN });
export const deleteBin = (payload) => ({ payload, type: DELETE_BIN });

export const loadBinsRequest = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/bins`, {
        withCredentials: true,
      });

      dispatch(loadBins(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const loadBinsByWarehouseRequest = (warehouse) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/bins/${warehouse}`, {
        withCredentials: true,
      });

      dispatch(loadBins(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const loadBinByIdRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/bins/id/${id}`, {
        withCredentials: true,
      });

      dispatch(loadBins(res.data));
      return res;
    } catch (e) {
      console.log(e);
    }
  };
};

export const addBinRequest = (data) => {
  return async (dispatch) => {
    try {
      console.log(data);
      let res = await axios.post(`${API_URL}/bins`, data, {
        withCredentials: true,
      });

      dispatch(addBin(res.data));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const editBinRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/bins/${data.id}`, data, {
        withCredentials: true,
      });
      dispatch(editBin(res.data));
    } catch (e) {
      return e.message.status;
    }
  };
};

export const deleteBinRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/bins/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteBin(id));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

const binsReducer = (statePart = initialState, action) => {
  switch (action.type) {
    case ADD_BIN:
      return [...statePart, action.payload];
    case EDIT_BIN:
      return statePart.map((el) =>
        el.id === action.payload.id ? action.payload : el,
      );
    case DELETE_BIN:
      return [...statePart.filter((el) => el.id !== action.payload)];
    case LOAD_BINS:
      return action.payload;
    default:
      return statePart;
  }
};

export default binsReducer;
